import { ScrollableModal } from '@/components/widgets/scrollable-modal/scrollable-modal';
import { useDismissPopupStates } from '@/features/promotion/cwc-risk-free-bet/hooks/use-dismiss-popup-states';
import { usePackPopupStates } from '@/features/promotion/cwc-risk-free-bet/hooks/use-pack-popup-states';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useGetWinnerList } from '@/hooks/sport-event/use-get-winner-list';
import { useAppearanceStore } from '@/store/appearance';
import { ViewEnum } from '@/types';
import { PackPopupType } from '@nf/types/promotion';
import { useTranslations } from 'next-intl';
import React, { useEffect, useState } from 'react';
import { AutoPopupKey, useRegisterAutoPopup } from '@nf/auto-popup-handler';

export const WinnerNotifyPopup = () => {
	const isGalaxyView = useAppearanceStore(state => state.view) === ViewEnum.galaxy;
	const { SiteConfigsData: siteConfig } = useGetSiteConfigs();
	return isGalaxyView && siteConfig?.EnableSportEventWinnerList ? <WinnerNotifyPopupModal /> : null;
};

export const WinnerNotifyPopupModal = () => {
	const t = useTranslations('General');
	const [wantsToShow, setWantsToShow] = useState(false);
	const canShow = useRegisterAutoPopup({
		key: AutoPopupKey.SportEventWinnerNotify,
		isEnabled: wantsToShow,
	});
	const { user } = useAccountInfo();
	const { dismissPopupStates } = useDismissPopupStates();
	const { winnerListContainTestData } = useGetWinnerList();
	const isWinner = winnerListContainTestData?.some(winner => winner.IBCCustId === user?.ID);
	const { data: packPopupStates } = usePackPopupStates(
		[PackPopupType.KingBackWinner], 
		{ shouldCheck: !!isWinner }
	);
	const isKingBackPopupShow = packPopupStates?.[0].IsShow;

	useEffect(() => {
		if (user?.ID && isKingBackPopupShow === true) {
			setWantsToShow(true);
		}
	}, [isKingBackPopupShow, user?.ID]);

	const handleClose = () => {
		setWantsToShow(false);
		dismissPopupStates(PackPopupType.KingBackWinner);
	};

	return (
		<ScrollableModal
			isOpen={canShow}
			closeModal={() => {}}
			className="sport-event__winner-notify-modal-container"
		>
			<div className="sport-event__winner-notify-modal">
				<div className="sport-event__winner-notify-modal__title">
					<span>{t('lbl_KBWinPopup01')}</span>
				</div>
				<div className="sport-event__winner-notify-modal__desc">
					{t('lbl_KBWinPopup02')}
				</div>
				<div className="sport-event__winner-notify-modal__subdesc">
					{t('lbl_KBWinPopup03')}
				</div>
				<button
					className="sport-event__winner-notify-modal__cta-btn"
					onClick={handleClose}
				>
					{t('lbl_KBWinPopupBtn')}
				</button>
			</div>
		</ScrollableModal>
	);
}; 